import {CouponValidationResponse} from "../../../features/coupons/coupons.types";
import {SsPromotionalArticleData, SsResultStatusCode} from "../../../features/stockstore-pos/stockstore-pos.types";

export interface MockCouponData {
  code: string;
  response: CouponValidationResponse;
  statusCode: SsResultStatusCode
}

// Mock data for coupon testing
export const CouponsTestData: MockCouponData[] = [
  // Coupon that will be removed at first calculate
  {
    code: "REMOVE",
    statusCode: SsResultStatusCode.OK,
    response: {
      promoName: "This should be removed"
    }
  },
  // Second coupon that will be removed at first calculate. Can be used to test multiple removed coupons.
  {
    code: "REMOVE2",
    statusCode: SsResultStatusCode.OK,
    response: {
      promoName: "This should be removed2"
    }
  },
  // Valid discount coupon
  {
    code: "DISCOUNT10",
    statusCode: SsResultStatusCode.OK,
    response: {
      promoName: "Sconto 10%"
    }
  },

  // Valid 20% discount coupon
  {
    code: "SAVE20",
    statusCode: SsResultStatusCode.ERR_COUPON_MAX_USAGE_LIMIT_REACHED,
    response: {
      promoName: "Sconto 20%"
    }
  },

  // Promotional article coupon
  {
    code: "FREEBURGER",
    statusCode: SsResultStatusCode.OK_COUPON_ARTICLE_PROMO,
    response: {
      promoName: "Burger Omaggio",
      promotionalArticleInfo: {
        articleCode: "V001",
        priceOverride: 0, // Free
        promoCode: 'BURGERPROMO'
      } as SsPromotionalArticleData
    }
  },
  // Promotional bundle coupon
  {
    code: "MENUBUR",
    statusCode: SsResultStatusCode.OK_COUPON_ARTICLE_PROMO,
    response: {
      promoName: "Burger menu Omaggio",
      promotionalArticleInfo: {
        articleCode: "B001",
        priceOverride: 800,
        promoCode: 'BURGERPROMO'
      } as SsPromotionalArticleData
    }
  },
  // Promotional article coupon with discounted price
  {
    code: "HALFPIZZA",
    statusCode: SsResultStatusCode.OK_COUPON_ARTICLE_PROMO,
    response: {
      promoName: "Pizza a Metà Prezzo",
      promotionalArticleInfo: {
        articleCode: "V009",
        priceOverride: 500, // 5.00 euros in cents,
        promoCode: 'PIZZAPROMO'
      } as SsPromotionalArticleData
    }
  },

  // Coupon not found
  {
    code: "INVALID123",
    statusCode: SsResultStatusCode.ERR_COUPON_NOT_FOUND,
    response: {}
  },

  // Invalid coupon
  {
    code: "EXPIRED456",
    statusCode: SsResultStatusCode.ERR_COUPON_NOT_VALID,
    response: {}
  },

  // Coupon already in use
  {
    code: "USED789",
    statusCode: SsResultStatusCode.ERR_COUPON_IN_USE,
    response: {}
  }
];
